import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { useBreakpoints } from "@qgiv/core-react";
import { Button, ProcessingButton } from "@qgiv/core-donor";
import ConnectedPaymentBackButton from "./ConnectedPaymentBackButton";

// Toggles the markup of the submit button label based on whether or not the
// registrationTotal is > 0
const SubmitButtonLabel = ({ renderSubmitButtonLabel }) => (
    <>{renderSubmitButtonLabel()}</>
);
SubmitButtonLabel.propTypes = {
    renderSubmitButtonLabel: PropTypes.func.isRequired,
};

const SubmitButtonSection = ({
    isApplePay,
    isCms,
    renderSubmitButtonLabel,
}) => {
    const { isSubmitting } = useFormikContext();

    // Display the processing state once Apple Pay was not responsible for the
    // form submission
    return (
        <div className="col col--12 col--xl-6">
            {isSubmitting && !isApplePay ? (
                <ProcessingButton />
            ) : (
                <Button
                    type="submit"
                    name="Submit_Button"
                    onClick={(e) => {
                        if (isCms) {
                            e.preventDefault();
                            // eslint-disable-next-line no-useless-return
                            return;
                        }
                    }}
                >
                    <SubmitButtonLabel
                        renderSubmitButtonLabel={renderSubmitButtonLabel}
                    />
                </Button>
            )}
        </div>
    );
};

SubmitButtonSection.propTypes = {
    isApplePay: PropTypes.bool.isRequired,
    isCms: PropTypes.bool.isRequired,
    renderSubmitButtonLabel: PropTypes.func.isRequired,
};

// -------------------------------------------------------------------------
// TODO:
// 1. Make the processing background a separate component from the
// processing button.
// 2. Once the functionality for the "optional" text has been built into the
// inputs, disable the submit button if there are any Formik errors in order
// to keep the UI pattern from the classification page consistent.
// -------------------------------------------------------------------------
const Submit = ({
    displaySubmit,
    controlId,
    isApplePay,
    isCms = false,
    renderSubmitButtonLabel,
}) => {
    const { isGreaterThanXLS } = useBreakpoints();

    // If an attempt is made to use Apple Pay hide the back and the submit
    // buttons until the I don't want to use Apple Pay button is clicked.
    return (
        displaySubmit && (
            // eslint-disable-next-line tailwindcss/classnames-order
            <div className="grid grid--align-items-center -margin-top--30">
                {isGreaterThanXLS ? (
                    <>
                        <div className="col col--12 col--xl-6">
                            <ConnectedPaymentBackButton controlId={controlId} />
                        </div>
                        <SubmitButtonSection
                            isApplePay={isApplePay}
                            isCms={isCms}
                            renderSubmitButtonLabel={renderSubmitButtonLabel}
                        />
                    </>
                ) : (
                    <>
                        <SubmitButtonSection
                            isApplePay={isApplePay}
                            isCms={isCms}
                            renderSubmitButtonLabel={renderSubmitButtonLabel}
                        />
                        <div className="col col--12 col--xl-6">
                            <ConnectedPaymentBackButton controlId={controlId} />
                        </div>
                    </>
                )}
            </div>
        )
    );
};

Submit.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    isApplePay: PropTypes.bool.isRequired,
    isCms: PropTypes.bool.isRequired,
    renderSubmitButtonLabel: PropTypes.func.isRequired,
    displaySubmit: PropTypes.bool.isRequired,
};

export default Submit;
